import {PcHeaderWrap, PcHeaderLeft, PcHeaderRight, PcHeaderUserTab} from 'src/styles/common/header'
import HeaderLogo from 'src/assets/common/header_logo.png'
import {NavLink, useNavigate} from 'react-router-dom'
import {BtnW172H44, BtnW92H44} from 'src/styles/common/CommonForm/buttonform'
import {COLOR} from 'src/service/constant/color'
import React, {useEffect} from 'react'
import {useLocation} from 'react-router'
import {APP_STORE_WARD, IOS_APP_STORE_WARD, MO_APP_STORE_WARD} from 'src/service/constant/url'
import header_person from 'src/assets/common/header_icon.png'
import {useCookies} from "react-cookie"
import {UserLogoutQueryData, UserSessionQueryData} from "src/hooks/reactquery"
import {TYPE_LOGOUT, TYPE_SESSION} from "src/service/constant/cmdtype"
import {useRecoilState} from "recoil"
import {HeaderUserTab} from "src/store/recoil/common"
import {deviceDetection} from 'src/service/utils'
import useWindowDimensions from "src/hooks/useGetWindowSize";

const UserSubTab = [
    {title: "마이페이지", link: "/userPage/main"},
    {title: "패밀리레터", link: "/userPage/letter/health"},
    {title: "오늘의 운세", link: "/userPage/fortune"},
]
const PcHeader = () => {
    const {pathname} = useLocation()
    const navigate = useNavigate()
    const [UserTab, setUserTab] = useRecoilState(HeaderUserTab)
    const [cookies, , removeCookie] = useCookies(['Famliycare'])
    const {data: UserSession, isSuccess} = UserSessionQueryData(TYPE_SESSION, cookies?.Famliycare)
    const {width} = useWindowDimensions()
    const {mutateAsync: UserLogout} = UserLogoutQueryData(TYPE_LOGOUT, cookies?.Famliycare)
    const loginStatus = UserSession?.Header?.ErrMsg === "정상" && cookies?.Famliycare !== undefined
    const Logout = () => {
        UserLogout().then(async r => {
            await removeCookie('Famliycare', {path: '/'})
            navigate('/')
            setUserTab(false)
        }).catch(() => {
            window.location.reload()
        })
    }

    const onClickAppDownload = () => {
        switch(deviceDetection()){
            case "AOS":
                window.open(width > 1200 ? APP_STORE_WARD : MO_APP_STORE_WARD)
                break
            case "IOS":
                window.open(IOS_APP_STORE_WARD)
                break
        }
    }

    useEffect(() => {
        if(isSuccess){
            switch (true){
                case (!loginStatus && pathname.includes("/userPage")):
                case (loginStatus && pathname.includes("/login")):
                    return navigate("/")
            }
        }
    }, [isSuccess, loginStatus, navigate, pathname])

    return (
        <PcHeaderWrap>
            <PcHeaderLeft>
                <img src={HeaderLogo} alt='헤더 이미지' onClick={() => navigate('/')}/>
            </PcHeaderLeft>
            <PcHeaderRight>
                <NavLink to={'/join'}>서비스 가입</NavLink>
                <NavLink to={'/notice'}>고객지원</NavLink>
                <NavLink to={'/cancel'}>서비스해지</NavLink>
                <section>
                    <BtnW172H44 color={`${COLOR.point1}`} onClick={onClickAppDownload}>
                        앱 설치하기
                    </BtnW172H44>
                    {isSuccess && loginStatus ?
                        <img src={header_person}
                             alt={'direct_userpage'}
                             onClick={() => setUserTab((prev) => !prev)}/>
                        :
                        <BtnW92H44>
                            <NavLink to={"/login"}>로그인</NavLink>
                        </BtnW92H44>
                    }
                </section>
            </PcHeaderRight>
            <PcHeaderUserTab display={`${UserTab}`}>
                {UserSubTab.map((element: any, index: number) => (
                    <NavLink to={element.link}
                             key={index}
                             style={{color: `${pathname.indexOf(element.link) >= 0 ? COLOR.gray50 : COLOR.gray40}`}}>
                        {element.title}
                    </NavLink>
                ))}
                <p onClick={Logout}>로그아웃</p>
            </PcHeaderUserTab>
        </PcHeaderWrap>
    )
}

export default PcHeader
